import { QualityScore } from "../../types/api";
import { FileText, Tag, Search, Image } from "lucide-react";
import { SuggestedAction } from "./scoreSlice";
import i18next from "i18next";

const getActionSubtext = (actionType: string, score: number) => {
  const isQuickWin = score > 60;
  const label = isQuickWin ? i18next.t("dashboard.quick_win_label" as const) : i18next.t("dashboard.high_impact_label" as const);
  return `${label} • ${Math.round(score)}% ${i18next.t("dashboard.complete" as const)}`;
};

const getRecommendedActions = (qualityScore: QualityScore, maxActions = 3) : SuggestedAction[] => {
  if (!qualityScore) return [];

  const actionableMetrics = [
    {
      title: i18next.t("dashboard.product_titles" as const),
      score: qualityScore.total_title_score,
      action: i18next.t("dashboard.enhance_titles" as const),
      enrichmentFeatures: ["title"],
      icon: FileText,
      count: Math.round((qualityScore.total_product_count || 0) * (1 - (qualityScore.total_title_score || 0) / 100)),
      threshold: 70,
      priority: 1
    },
    {
      title: i18next.t("dashboard.product_descriptions" as const),
      score: qualityScore.total_desc_html_score,
      action: i18next.t("dashboard.write_descriptions" as const),
      enrichmentFeatures: ["description"],
      icon: FileText,
      count: Math.round((qualityScore.total_product_count || 0) * (1 - (qualityScore.total_desc_html_score || 0) / 100)),
      threshold: 70,
      priority: 2
    },
    {
      title: i18next.t("dashboard.visual_content" as const),
      score: qualityScore.total_images_count_score,
      action: i18next.t("dashboard.add_images" as const),
      enrichmentFeatures: ["image_finder"],
      icon: Image,
      count: Math.round((qualityScore.total_product_count || 0) * (1 - (qualityScore.total_images_count_score || 0) / 100)),
      threshold: 80,
      priority: 3
    },
    {
      title: i18next.t("dashboard.image_alt_texts" as const),
      score: qualityScore.total_alt_text_score,
      action: i18next.t("dashboard.add_alt_texts" as const),
      enrichmentFeatures: ["altText"],
      icon: Tag,
      count: Math.round((qualityScore.total_product_count || 0) * (1 - (qualityScore.total_alt_text_score || 0) / 100)),
      threshold: 60,
      priority: 4
    },
    {
      title: i18next.t("dashboard.seo_optimization" as const),
      score: qualityScore.total_seo_description_score,
      action: i18next.t("dashboard.improve_seo" as const),
      enrichmentFeatures: ["seo"],
      icon: Search,
      count: Math.round((qualityScore.total_product_count || 0) * (1 - (qualityScore.total_seo_description_score || 0) / 100)),
      threshold: 70,
      priority: 5
    },
    
    
 /*    {
      title: "Category Organization",
      score: qualityScore.total_category_prodtype_score,
      action: "Optimize Categories",
      enrichmentFeatures: ["categoryPlacement"],
      icon: Database,
      count: Math.round((qualityScore.total_product_count || 0) * (1 - (qualityScore.total_category_prodtype_score || 0) / 100)),
      threshold: 70,
      priority: 6
    }, */


    {
      title: i18next.t("dashboard.product_tags" as const),
      score: qualityScore.total_tags_score,
      action: i18next.t("dashboard.add_product_tags" as const),
      enrichmentFeatures: ["productTags"],
      icon: Tag,
      count: Math.round((qualityScore.total_product_count || 0) * (1 - (qualityScore.total_tags_score || 0) / 100)),
      threshold: 70,
      priority: 7
    }
  ];

  return actionableMetrics
    .filter(metric => 
      metric.count > 0 && 
      (metric.score || 0) < metric.threshold
    )
    .sort((a, b) => {
      const countDiff = b.count - a.count;
      if (countDiff !== 0) return countDiff;
      
      const aGap = a.threshold - (a.score || 0);
      const bGap = b.threshold - (b.score || 0);
      if (bGap !== aGap) return bGap - aGap;
      
      return a.priority - b.priority;
    })
    .slice(0, maxActions)
    .map(metric => ({
      ...metric,
      subtext: getActionSubtext(metric.action, metric.score || 0),
    })) as SuggestedAction[];
};

export default getRecommendedActions